export const HERO_CONSTANTS = {
  button: {
    label: "Start your cloud lab experience today",
    link: "#contact-us",
  },
  title: "On-Demand Cloud Labs for Testing & Development",
};
